module.exports = __webpack_public_path__ + "static/media/israel-henrique.768b555b.png";